<div class="health-log-container">
  
  <!-- Header with back button and title -->
  <div class="header">
    <button class="back-btn" (click)="goBack()">
      <i class="fas fa-chevron-left"></i>
    </button>
    <h1 class="page-title">Vitals</h1>

    <button *ngIf="update_dr?.length > 0" class="add-new-btn disnew" mat-raised-button (click)="openDialog()"
      [disabled]="update_dr?.length >= 5" matTooltip="Maximum 5 devices are allowed">
      <span class="btn-text"> + Add Vitals</span>
    </button>
  </div>


  <!-- Content Area -->
  <div class="content">

    <!-- Empty State -->
    <div class="empty-state" *ngIf="update_dr?.length === 0">
      <img src="assets/images/health/homeimg/Group 1000004191.svg">
      <h3>No Devices Added Yet..</h3>
      <p>Add new connections to keep track of your digital relationships</p>
      <button class="add-new-btn" mat-raised-button (click)="openDialog()">
        <span class="btn-text"> + Add Vitals</span>
      </button>
    </div>

    <!-- device cards -->
    <div class="medication-grid" *ngIf="update_dr?.length !== 0">
        <div class="medication-card" *ngFor="let device of update_dr | filterAll:searchText"  [routerLink]="['/health/device', device.systemId]">
        <div class="card-header">
            <div class="med-icon">
              <!-- <i class="{{device.image[0]}}" [style]="device.image[1]"></i> -->
             <i *ngIf="deviceIcon(device.systemId) as icon; else deviceImg" [class]="icon" [attr.title]="device.title" aria-hidden="true"></i>
             <ng-template #deviceImg><img [src]="device.image" alt="{{device.title}}" class="device-img"/></ng-template></div>
            <div class="med-title-group">
            <h3 class="med-name">{{ device.title }}</h3>
            </div>

            <div class="card-actions">
            <button mat-icon-button [matMenuTriggerFor]="menuFamHistory" (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menuFamHistory="matMenu">
                <button mat-menu-item (click)="onEdit(device);">
                <!-- <mat-icon>edit</mat-icon> -->
                <img class="imgbtn" src="assets/images/health/icons/system-uicons_list-add.svg" />&nbsp;
                <span>Add Reading</span>
                </button>
                <button mat-menu-item (click)="onDelete(device);$event.stopPropagation()">
                <!-- <mat-icon>delete</mat-icon> -->
                <img class="imgbtn" src="assets/images/health/icons/fluent_delete-28-regular.svg" />&nbsp;
                <span>Delete Device</span>
                </button>
            </mat-menu>
            </div>
        </div>
         <div class="reading-values" *ngIf="device.value1 && device.systemId!='0x1810'">
              <span>{{device.value1}}</span> &nbsp;
              <span class="unit">{{device.valueUnit1}}</span>
              <div class="reading-time">
              <small>{{formattedDateTime(device.readingDateTime)}}</small>
            </div>
          </div>
          <div class="reading-values" *ngIf="device.value1 && device.systemId=='0x1810'">
            <span class="systolic">{{ device.value1 }}</span> /
            <span class="diastolic">{{ device.value2 }}</span> &nbsp;
            <span class="unit">{{ device.valueUnit1 }}</span>
            <div class="reading-time">
              <small>{{formattedDateTime(device.readingDateTime)}}</small>
            </div>
          </div>
            
        </div>
    </div>



  </div>
</div>
<div class="upload-overlay" *ngIf="isUploading">
  <div class="logo-spinner">
    <img src="assets/images/vita-logo.png" alt="Loading..." />
  </div>
</div>